export const USAGE_METRIC = {
  CARE_PLAN_AUDITS: 'carePlanAudits',
  SUPERVISION_SESSIONS: 'supervisionSessions',
}

export const USAGE_METRICS = Object.values(USAGE_METRIC)

export const USAGE_METRIC_META = {
  [USAGE_METRIC.CARE_PLAN_AUDITS]: {
    label: 'Care plan audits',
    noun: 'audit',
    nounPlural: 'audits',
    /** Shown to a CareBrain admin while setting the number. */
    adminHint: 'Number of care plan audits this organisation may generate each month.',
    /** Shown to the customer next to their own counter. */
    customerHint: 'Audits generated from uploaded care plans.',
  },
  [USAGE_METRIC.SUPERVISION_SESSIONS]: {
    label: 'Supervision',
    noun: 'session',
    nounPlural: 'sessions',
    adminHint: 'Supervision sessions this organisation may run each month.',
    customerHint: 'Sessions run across your professionals.',
  },
}

export const DEFAULT_QCS_LIMITS = {
  [USAGE_METRIC.CARE_PLAN_AUDITS]: 10,
  [USAGE_METRIC.SUPERVISION_SESSIONS]: 10,
}

export const UNLIMITED = null

export const LIMIT_REQUEST_CONTACT_EMAIL = 'customerservice@qcs.co.uk'

export const USAGE_WARNING_THRESHOLD = 0.8

export const isUnlimited = limit => limit === null || limit === undefined

export const getRemaining = (used, limit) => {
  if (isUnlimited(limit)) return null
  return Math.max(limit - (used || 0), 0)
}

export const isExhausted = (used, limit) => {
  if (isUnlimited(limit)) return false
  return (used || 0) >= limit
}

export const getUsageRatio = (used, limit) => {
  if (isUnlimited(limit) || !limit) return 0
  return Math.min(Math.max((used || 0) / limit, 0), 1)
}

export const getNextResetDate = (from = new Date()) =>
  new Date(from.getFullYear(), from.getMonth() + 1, 1)

export const formatResetDate = periodEnd => {
  const date = periodEnd ? new Date(periodEnd) : getNextResetDate()
  if (Number.isNaN(date.getTime())) return 'the 1st of next month'
  return date.toLocaleDateString(undefined, { day: 'numeric', month: 'long' })
}
